// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2Z9NB","empty":"ModalGraph_empty__1Nfcq"};